export const wrapPageElement = ({element, props}) => {
  return element
}
